module.exports = __webpack_public_path__ + "static/media/yiyuan8.e6326bf1.png";